import React from "react";
import "./Internship_is_Ideal.css"

function Internship_is_Ideal({normal_text, bold_text}) {
  return (
    <>
      <section className="Internship_is_Ideal">
        <div className="container">
          <div className="text_holder">
            <h2>
              {normal_text} 
              <span>
                {bold_text}
              </span>
            </h2>
          </div>
        </div>
      </section>
    </>
  );
}

export default Internship_is_Ideal;
